"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Colour;
(function (Colour) {
    Colour["WHITE"] = "#FFFFFF";
    Colour["BLACK"] = "#000000";
    Colour["LIGHT_GRAY"] = "#BDBDBD";
    Colour["DARK_GRAY"] = "#4F4F4F";
    Colour["RED"] = "#EB5757";
    Colour["ORANGE"] = "#F2994A";
    Colour["YELLOW"] = "#F2C94C";
    Colour["LIGHT_GREEN"] = "#6FCF97";
    Colour["GREEN"] = "#219653";
    Colour["BLUE"] = "#2F80ED";
    Colour["PURPLE"] = "#9B51E0";
    Colour["BROWN"] = "#7f4411";
})(Colour = exports.Colour || (exports.Colour = {}));
var PenThickness;
(function (PenThickness) {
    PenThickness[PenThickness["SMALL"] = 8] = "SMALL";
    PenThickness[PenThickness["MEDIUM"] = 18] = "MEDIUM";
    PenThickness[PenThickness["LARGE"] = 36] = "LARGE";
})(PenThickness = exports.PenThickness || (exports.PenThickness = {}));
var PenType;
(function (PenType) {
    PenType["SOLID"] = "solid";
    PenType["ERASE"] = "erase";
})(PenType = exports.PenType || (exports.PenType = {}));
exports.CANVAS_WIDTH = 600;
exports.CANVAS_HEIGHT = 600;
